module.exports = __webpack_public_path__ + "static/media/medassisst.da4d9ed9.svg";